import { apiRequest } from '../api/client';

export const BILLING_CONCEPT_TYPES = ['PRODUCT', 'SERVICE'] as const;
export type BillingConceptType = (typeof BILLING_CONCEPT_TYPES)[number];

export const BILLING_CONCEPT_TYPE_LABELS: Record<BillingConceptType, string> = {
  PRODUCT: 'Producto',
  SERVICE: 'Servicio',
};

/** Matches `apps/api` `StoredBillingConceptWithUsage` (`billing-concept.repository.ts`). */
export interface BillingConcept {
  id: string;
  name: string;
  arcaType: BillingConceptType;
  defaultDescription: string | null;
  isActive: boolean;
  isSystemDefault: boolean;
  defaultVatRateId: string | null;
  defaultVatRate: { id: string; name: string; rate: number } | null;
  priceUsageCount: number;
  createdAt: string;
  updatedAt: string;
}

/** Matches `apps/api` `GET /billing-concepts`. */
export function listBillingConcepts(): Promise<BillingConcept[]> {
  return apiRequest<BillingConcept[]>('/billing-concepts');
}

/** Matches `apps/api` `BillingConceptOption` (`list-billing-concepts.use-case.ts`). */
export interface BillingConceptOption {
  id: string;
  name: string;
  arcaType: BillingConceptType;
  isSystemDefault: boolean;
  /** Lets the price form pre-fill the VAT rate without `fiscal.config`. */
  defaultVatRate: { id: string; rate: number } | null;
}

/** Matches `apps/api` `GET /billing-concepts/options` (`contract.price.manage`; active concepts only). */
export function listBillingConceptOptions(): Promise<BillingConceptOption[]> {
  return apiRequest<BillingConceptOption[]>('/billing-concepts/options');
}

export interface CreateBillingConceptInput {
  name: string;
  arcaType: BillingConceptType;
  defaultDescription?: string | null;
  defaultVatRateId?: string | null;
  isActive?: boolean;
}

/** Matches `apps/api` `POST /billing-concepts`. */
export function createBillingConcept(input: CreateBillingConceptInput): Promise<BillingConcept> {
  return apiRequest<BillingConcept>('/billing-concepts', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export type UpdateBillingConceptInput = Partial<CreateBillingConceptInput>;

/** Matches `apps/api` `PATCH /billing-concepts/:id`. */
export function updateBillingConcept(
  id: string,
  input: UpdateBillingConceptInput,
): Promise<BillingConcept> {
  return apiRequest<BillingConcept>(`/billing-concepts/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
